import AclName from '../AclName';

export default [
  AclName.BookkeepingInvoicesAccessAll,
];
